import apiClient from '../apiClient';
import { UPLOAD_PREVIEW_ACCOMODATION_PROFILE_URL } from '../apiUrl';

const uploadMasterDataPreviewAccomodationProfileApi = data => {
  return apiClient.post(UPLOAD_PREVIEW_ACCOMODATION_PROFILE_URL, data);
};

export default uploadMasterDataPreviewAccomodationProfileApi;
